export const handleSequenceGap = (params: {
  targetChatId: string;
  expectedSeq: number;
  seqValue: number;
  gapDetected: boolean;
  missingSeqRef: React.MutableRefObject<Map<string, number>>;
  missingSeqRetriesRef: React.MutableRefObject<Map<string, number>>;
  missingSeqTimersRef: React.MutableRefObject<Map<string, number>>;
  sequencedMessagesRef: React.MutableRefObject<Map<string, { nextSeq: number; buffer: Map<number, string>; lastSeq: number }>>;
  requestReplay: (targetChatId: string, lastSeq: number) => void;
  flushSequencedBuffer: (targetChatId: string, state: { nextSeq: number; buffer: Map<number, string>; lastSeq: number }) => void;
}) => {
  const {
    targetChatId,
    expectedSeq,
    seqValue,
    gapDetected,
    missingSeqRef,
    missingSeqRetriesRef,
    missingSeqTimersRef,
    sequencedMessagesRef,
    requestReplay,
    flushSequencedBuffer,
  } = params;

  const scheduleRetry = (missingFrom: number) => {
    const nextTimer = window.setTimeout(() => {
      const nextMissing = missingSeqRef.current.get(targetChatId);
      if (!nextMissing || nextMissing !== missingFrom) return;
      const pending = sequencedMessagesRef.current.get(targetChatId);
      if (pending && !pending.buffer.has(missingFrom)) {
        const retries = (missingSeqRetriesRef.current.get(targetChatId) ?? 0) + 1;
        missingSeqRetriesRef.current.set(targetChatId, retries);
        if (retries >= 3) {
          missingSeqRef.current.delete(targetChatId);
          missingSeqRetriesRef.current.delete(targetChatId);
          flushSequencedBuffer(targetChatId, pending);
          return;
        }
        const lastSeq = Math.max(0, missingFrom - 1);
        requestReplay(targetChatId, lastSeq);
        scheduleRetry(missingFrom);
      }
    }, 10_000);
    missingSeqTimersRef.current.set(targetChatId, nextTimer);
  };

  if (gapDetected) {
    const missingFrom = expectedSeq;
    missingSeqRef.current.set(targetChatId, missingFrom);
    if (missingSeqTimersRef.current.get(targetChatId)) return;

    const timerId = window.setTimeout(() => {
      const stillMissing = missingSeqRef.current.get(targetChatId);
      if (!stillMissing || stillMissing !== missingFrom) return;
      const pending = sequencedMessagesRef.current.get(targetChatId);
      if (pending && !pending.buffer.has(missingFrom)) {
        const retries = (missingSeqRetriesRef.current.get(targetChatId) ?? 0) + 1;
        missingSeqRetriesRef.current.set(targetChatId, retries);
        if (retries >= 3) {
          missingSeqRef.current.delete(targetChatId);
          missingSeqRetriesRef.current.delete(targetChatId);
          flushSequencedBuffer(targetChatId, pending);
          return;
        }
        const lastSeq = Math.max(0, missingFrom - 1);
        requestReplay(targetChatId, lastSeq);
        missingSeqTimersRef.current.delete(targetChatId);
        scheduleRetry(missingFrom);
      }
    }, 10_000);
    missingSeqTimersRef.current.set(targetChatId, timerId);
    return;
  }

  if (seqValue === expectedSeq) {
    const missing = missingSeqRef.current.get(targetChatId);
    if (missing && missing === seqValue) {
      missingSeqRef.current.delete(targetChatId);
      missingSeqRetriesRef.current.delete(targetChatId);
      const timerId = missingSeqTimersRef.current.get(targetChatId);
      if (timerId) {
        clearTimeout(timerId);
        missingSeqTimersRef.current.delete(targetChatId);
      }
    }
  }
};
